<script setup>
import { ref, computed, onMounted, onBeforeUnmount, nextTick, unref } from "vue";
import ArrowUp from "@/components/icons/ArrowUp.vue";

const props = defineProps({
  tableRef: { type: [Object, HTMLElement, null], required: true }
});

const scrollTop     = ref(0);
const scrollHeight  = ref(0);
const clientHeight  = ref(0);
let el = null;

// Обновление значений скролла
function update() {
  scrollTop.value    = el.scrollTop;
  scrollHeight.value = el.scrollHeight;
  clientHeight.value = el.clientHeight;
}

onMounted(async () => {
  await nextTick();
  const container = unref(props.tableRef);
  // ищем внутренний скролл-контейнер
  el = container.querySelector(".table__scroll") || container;
  if (!el) return;
  update();
  el.addEventListener("scroll", update);
});

onBeforeUnmount(() => {
  el?.removeEventListener("scroll", update);
});

const showUp   = computed(() => scrollTop.value > 0);
const showDown = computed(() => scrollTop.value + clientHeight.value < scrollHeight.value);

function scrollUp() {
  el.scrollTo({ top: 0, behavior: "smooth" });
}
function scrollDown() {
  el.scrollTo({ top: scrollHeight.value, behavior: "smooth" });
}
</script>

<template>
  <div class="table-scroll-buttons">
    <ButtonAccentPrimary
      v-if="showUp"
      size="large"
      class="table-scroll-buttons__button table-scroll-buttons__button--up"
      @click="scrollUp"
    >
      <ArrowUp />
    </ButtonAccentPrimary>

    <ButtonAccentPrimary
      v-if="showDown"
      size="large"
      class="table-scroll-buttons__button table-scroll-buttons__button--down"
      @click="scrollDown"
    >
      <ArrowUp />
    </ButtonAccentPrimary>
  </div>
</template>

<style scoped lang="scss">
.table-scroll-buttons {
  position: fixed;
  right: 20px;
  bottom: 50px;
  display: flex;
  gap: 10px;
  z-index: 100;
}

.table-scroll-buttons__button {
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
  padding: 0;
  z-index: -1;

  &--down {
    svg { transform: rotate(180deg); }
  }
}
</style>
